
const MENU = [
  {
    id: 1,
    title: 'Популярные',
    path: '/navigator/streams',
  },
  {
    id: 2,
    title: 'Новые',
    path: '/navigator/streams/new',
  },
]
export default {
  name: 'PagesNavigatorHeader',
  data() {
    return {
      collection: null,
    }
  },

  async fetch() {
    await this.fetchCollection()
  },
  computed: {
    menu() {
      return MENU
    },
  },
  watch: {
    '$route.params'() {
      if (!this.$route.params?.url) {
        this.collection = null
      }
      this.fetchCollection()
    },
  },

  methods: {
    async fetchCollection() {
      const url = this.$route.params?.url

      if (url) {
        const fields = {
          title: true,
        }
        const collection = await this.$axios.$get(`/collection/${url}`, {
          params: {
            filter: fields,
          },
        })

        if (collection) {
          this.collection = collection
        }
      }
    },
  },
}
